import {Component, OnInit} from '@angular/core';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'ngx-check-data',
  styleUrls: ['./check-data.component.scss'],
  templateUrl: './check-data.component.html',
  providers: [PeticionesHttpBackEndService]
})
export class CheckDataComponent implements OnInit{

  constructor(private router:Router,private authService: NbAuthService,public _http: PeticionesHttpBackEndService){

  }

  RequestResult:any;

  ngOnInit(){
    $(".menu-sidebar").hide();

    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {

        this._http.getUsuario().subscribe(
          result => {
            this.RequestResult = result;
            
            if (this.RequestResult.Entidad._rol_id == 3){
              if (this.RequestResult.Entidad._borrado == 1){
                /* Si el usuario ha sido borado */
                localStorage.clear();
                this.router.navigate(['public/deleted-user']);

              }else{
                localStorage.setItem('R_U', ''+this.RequestResult.Entidad._rol_id+'');
                if(localStorage.getItem("C_BUY")){
                  $(".menu-sidebar").show();
                  this.router.navigate(['public/inicio']);
                }else{
                  this.router.navigate(['public/inicio']);
                }
                
              }
              
            }else if (this.RequestResult.Entidad._rol_id == 1 || this.RequestResult.Entidad._rol_id == 2){
              if (this.RequestResult.Entidad._borrado == 1){
                /* Si el usuario ha sido borado */
                localStorage.clear();
                this.router.navigate(['public/deleted-user']);

              }else{
                $(".menu-sidebar").show();
                this.router.navigate(['private/control-panel']);
              }
              
            }
          },
          error => {}
        );


      }
    }); 
  }

}
